import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { UnsafeAction } from "./UnsafeAction"

import * as model from "../models";

/* tslint:disable */
@Injectable()
export class EventOverviewActions {

	static EVENT_OVERVIEW_LOADED = "[EventOverview] EventOverview loaded";
	eventOverviewLoaded(eventsWithVenues: model.EventWithVenue[]): UnsafeAction {
		return {
			type: EventOverviewActions.EVENT_OVERVIEW_LOADED,
			payload: eventsWithVenues
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/actions/event-overview.actions.ts